<template>
    <v-chip
        v-bind="$attrs"
        v-if="!!value"
        @click="onNotion(value)"
        label
        color="edit_icon"
        outlined
    >
      <span>N</span>
    </v-chip>
</template>

<script>

export default {
  name: 'BaseNotionLink',
  props:
      {
        value: {default: null},
        // color: {default: 'primary'},
        icon: {default: 'mdi-alpha-n-box-outline'},
      },
  data() {
    return {}
  },

  components: {},

  methods: {
    onNotion(notion_uid) {
      // console.log('onNotion', item)
      window.open('https://www.notion.so/' + notion_uid.replace(/-/g, ''), '_blank')
    },
  },

  mounted() {
  },

}
</script>

<style scoped lang="scss">

* {
  font-size: 14px;
  font-weight: bold;
}

.year-week, .deliveries {
  color: white;
}

.text-title, .percent-avatar {
  color: lightgrey;
}

</style>